module.exports = __webpack_public_path__ + "images/temporary/sms-chart.svg";